import { useFormContext } from '@/lib/form-contexts'
import { useParams } from '@tanstack/react-router'
import { type ComponentProps, type SubmitEvent, useEffect, useEffectEvent, useRef } from 'react'

export type FormProps = ComponentProps<'form'>

export default function Form({ children, ...props }: FormProps) {
  const form = useFormContext()

  const handleSubmit = (e: SubmitEvent<HTMLFormElement>) => {
    e.preventDefault()
    e.stopPropagation()
    void form.handleSubmit()
  }

  // If a global user switches orgs while editing settings, reset the form
  const params: unknown = useParams({ strict: false })
  const orgId =
    typeof params === 'object' && params !== null && 'orgId' in params ? params.orgId : undefined
  const hasMountedRef = useRef(false)

  // No need to re-run when form changes
  const resetForm = useEffectEvent(() => form.reset())
  useEffect(() => {
    if (!hasMountedRef.current) {
      hasMountedRef.current = true
      return
    }

    resetForm()
  }, [orgId])

  return (
    <form onSubmit={handleSubmit} {...props}>
      {children}
    </form>
  )
}
